class CollectionSortBar extends HTMLElement {
  connectedCallback() {
    this.sortBar = this.querySelector('.collection__sort-bar');
    this.button = this.querySelector('.collection__sort__label');
    this.textEl = this.button?.querySelector('.text');
    this.inputs = this.querySelectorAll('[data-input-sort]');

    if (!this.sortBar || !this.button || !this.inputs.length) return;

    this.onChange = this.onChange.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);

    this.bindEvents();
    this.syncOnLoad();
  }

  disconnectedCallback() {
    this.inputs.forEach(input => {
      input.removeEventListener('change', this.onChange);
    });

    this.button.removeEventListener('click', this.onToggle);
    document.removeEventListener('click', this.onClickOutside);
  }

  bindEvents() {
    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChange);
    });

    this.button.addEventListener('click', this.onToggle);

    document.addEventListener('click', this.onClickOutside);
  }

  onToggle(e) {
    e.stopPropagation(); 
    this.sortBar.classList.toggle('active');
  }

  onClickOutside(e) {
    if (!this.contains(e.target)) {
      this.sortBar.classList.remove('active');
    }
  }

  onChange(e) {
    const input = e.target;
    if (!input.checked) return;

    this.updateButton(input);

    this.sortBar.classList.remove('active');
  }

  updateButton(input) {
    const label = this.querySelector(`label[for="${input.id}"]`);
    if (!label || !this.textEl) return;

    this.textEl.textContent = label.textContent.trim();
  }

  syncOnLoad() {
    const checked = this.querySelector('[data-input-sort]:checked');
    if (checked) this.updateButton(checked);
  }
}

customElements.define('collection-sort-bar', CollectionSortBar);
